import React from 'react'
import { NO_VALUE } from '../math/format'
import './org-dashboard.scss'

/** The class the stylesheet's Total row rules hang on, for every dashboard table that closes with a Total row. */
export const TABLE_TOTALS_ROW_CLASS_NAME = 'org-dashboard-totals-row'

type LabelProps = {
    /** What the total covers, short enough to sit beside "Total" on one line: "3 of 5 sent". */
    coverage?: string
    /** The coverage in full, for the hover title and for assistive technology, when `coverage` is shortened. */
    coverageInFull?: string
}

/** "Total" in bold with its coverage muted after it on the same line, so the row is no taller than a row of figures. */
export const TotalsLabel: React.FC<LabelProps> = ({ coverage, coverageInFull }) => (
    <span className="org-dashboard-totals-label">
        <strong>Total</strong>
        {coverage ? (
            <span className="org-dashboard-totals-coverage" title={coverageInFull}>
                <span aria-hidden={coverageInFull ? true : undefined}>{coverage}</span>
                {coverageInFull ? <span className="org-dashboard-visually-hidden">{coverageInFull}</span> : null}
            </span>
        ) : null}
    </span>
)

/** A total's figure alone: no change line and no reserved space for one. */
export const TotalsFigure: React.FC<{ text: string }> = ({ text }) => (
    <span className={text === NO_VALUE ? 'org-dashboard-dash' : undefined}>{text}</span>
)
